// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon[data-v-79f8591c] {\n  color: #452970;\n}\n\n.button[data-v-79f8591c] {\n  z-index: 0;\n}", ""]);
// Exports
module.exports = exports;
